import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import Topbar from '../layout/Topbar';
import { useBookStore } from '../../provider/BookStore';
import { useMasterStore } from '../../provider/MasterStore';

const AddCategory = () => {

    const location = useLocation();
    const bookState = useBookStore();
    const book = bookState.book;
    // untuk membuang cache kategori setelah data berubah
    const masterStore = useMasterStore();
    const category = location.state.data;
    const action = location.state.action;
    const navigate = useNavigate();

    const [msg, setMsg] = useState('');
    const [title, setTitle] = useState('');
    const [selectedType, setSelectedType] = useState('kredit');

    useEffect(() => {
        console.log(category);
        if (action === 'edit') {
            setTitle(category.title)
            setSelectedType(category.type)
        }
    }, []);

    const createCategory = async (e) => {
        e.preventDefault()
        try {
            if (action === 'edit') {
                await api.post('category/save', {
                    category_id: category.id,
                    book_id: book.id,
                    type: selectedType,
                    title: title
                });
            } else {
                await api.post('category/add', {
                    book_id: book.id,
                    type: selectedType,
                    title: title
                });
            }

            navigate('/categories')
        } catch (error) {
            const message = error.response.data.messages.message;
            setMsg(message)
            console.log(message)
        } finally {
            // sukses maupun gagal validasi server, cache kategori buku ini
            // dibuang agar form & daftar di halaman lain tidak pakai data lama
            masterStore.invalidateCategories(book.id);
        }
    }

    const deleteCategory = async (e) => {
        e.preventDefault()
        try {
            await api.post('category/delete', {
                category_id: category.id
            })

            navigate('/categories')
        } catch (error) {
            console.error('Gagal menghapus kategori:', error?.response || error?.message);
        } finally {
            masterStore.invalidateCategories(book.id);
        }
    }

    return (
        <div>
            <Topbar
                title={action === 'edit' ? 'Edit Kategori' : 'Tambah Kategori'}
                back={() => navigate('/categories')}
            />
            <div className="container p-5">
                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">

                        <p className='is-size-6 mb-4 ml-4'>Buku Kas : {book.title}</p>

                        <form onSubmit={createCategory} className="card">
                            <div className='card-content'>
                                <p className="has-text-centered">{msg}</p>
                                <div className="field mt-5">
                                    {/* <label className="label">Keterangan</label> */}
                                    <div className="control">
                                        <label className='radio'>
                                            <input type="radio" name='type' className='mr-2' checked={selectedType === 'debit'}
                                                value='debit' onChange={(e) => setSelectedType(e.target.value)} />
                                            Debit
                                        </label>
                                        <label className='radio'>
                                            <input type="radio" name='type' className='mr-2 ml-4' checked={selectedType === 'kredit'}
                                                value='kredit' onChange={(e) => setSelectedType(e.target.value)} />
                                            Kredit
                                        </label>
                                    </div>
                                </div>
                                <div className="field mt-5">
                                    <label className="label">Kategori</label>
                                    <div className="controls">
                                        <input type="text" className="input" placeholder='Kategori'
                                            value={title} onChange={(e) => setTitle(e.target.value)} />
                                    </div>
                                </div>
                            </div>

                            <footer className="card-footer">
                                <button className="card-footer-item has-text-danger " onClick={deleteCategory}>Hapus</button>
                                <button className="card-footer-item ">Simpan</button>
                            </footer>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddCategory
